import { AggregatorSpeciality } from '@/types-aggregatore';
import { makeProfile } from '@/utils/profile';

export const mapSpecializationToCard = (specialization: AggregatorSpeciality, profile: ReturnType<typeof makeProfile>) => {
  return {
    address: profile.address?.street,
    cap: profile.address?.cap,
    city: profile.address?.cityName,
    logoUrl: profile.imageSrc,
    name: profile.name,
    specializations: {
      hasDynamicPrice: specialization.hasDynamicPrice,
      hasDescription: !!specialization.eltyDescription || !!specialization.medicalInstructions,
      label: specialization.label,
      doctors:
        specialization.doctors
          ?.filter(v => !!v)
          .map(aggregatorDoctor => {
            return {
              ...aggregatorDoctor,
              price: aggregatorDoctor?.basePrice ?? undefined,
            };
          }) ?? [],
      favorite: specialization.favorite ?? false,
      id: specialization.id!,
      macroSpeciality: specialization.macroSpeciality,
      macroSpecialityKey: specialization.macroSpeciality,
      specialityChannels: specialization.specialityChannels?.filter(v => v) ?? [],
    },
    objectID: `${profile.id}:${specialization.doctors?.[0]?.id}:${specialization.id}`,
    domiciliaryCare: profile.domiciliaryCare,
    ambulatoryId: profile.id,
    slug: profile.inclinicSlug,
    availablePayments: profile.availablePayments ?? [],
    license: profile.license,
    review: null,
  };
};
